import axios from "axios";
import {Message} from "element-ui";

const request = axios.create();
request.defaults.timeout = 600000; // 默认超时时间
request.defaults.validateStatus = status => status >= 200 && status <= 500; // 返回true，promise将被resolve，返回false，promise将被reject
request.defaults.withCredentials = true; // 跨域请求，允许保存cookie

// 请求拦截
request.interceptors.request.use(
  config => {
    if (sessionStorage.token) {
      config.headers.token = `${sessionStorage.token}`;
    } else {
      let userType = sessionStorage.userType;
      var href = location.href;
      if (
        href.indexOf("login") < 0 &&
        href.indexOf("adminLogin") < 0 &&
        href.indexOf("mobile/login") < 0 &&
        href.indexOf("mobile/dingLogin") < 0 &&
        href.indexOf("/wechat/auth") < 0 &&
        href.indexOf("/dingTalk/auth") < 0 &&
        href.indexOf("/mobile/mobileCustomerSatisfactionEdit") < 0 &&
        href.indexOf("/customerManage/customerSatisfactionEdit") < 0 &&
        // href.indexOf("/mobile/addRepairCustomer") < 0 && //客户需求登记页面
        href.indexOf("/materialManage/stock-transfer/abnormalForm-dingTalk") < 0 &&//钉钉异常处理
        href.indexOf("/materialManage/material-transfer/abnormalForm-dingTalk") < 0 &&
        href.indexOf("/materialManage/purchase-receive/abnormalForm-dingTalk") < 0
      ) {
        if (userType == "superAdmin") {
          window.location.href = "/#/adminLogin";
        } else {
          if (href.indexOf("admin") > -1) {
            window.location.href = "/#/adminLogin";
          } else if (href.indexOf("dingLogin") > -1) {
            window.location.href = "/#/mobile/dingLogin";
          } else if (href.indexOf("mobile") > -1) {
            if (href.indexOf("mobile/errorMessageDetail") < -1) {
              window.location.href = "/#/mobile/login";
            }
          } else if (href.indexOf("wechat") > -1) {
            window.location.href = "/#/wechat/auth";
          } else if (href.indexOf("wechat") > -1) {
            window.location.href = "/#/dingTalk/auth";
          } else {
            window.location.href = "/#/login";
          }
        }
        if (href.indexOf("mobile/errorMessageDetail") < -1) {

          alert("对不起，您尚未登录，请先登录！");
        }
      }
    }
    return config;
  },
  err => {
    return Promise.reject(err);
  }
);

// 响应拦截
request.interceptors.response.use(
  res => {
    let status = "";
    let message = "";
    if (typeof res.data === "string") {
      status = JSON.parse(res.data).code;
      message = JSON.parse(res.data).message;
    } else {
      status = res.data.code;
      message = res.data.message;
    }

    // 获取状态码
    // const status = res.data.code || res.status;
    // let message = res.data.msg || res.data.error_description || "未知错误";
    // 如果是401则跳转到登录页面
    // if (status === 401) {
    //   store.dispatch("FedLogOut");
    //   store.commit("SET_LOGIN_DIALOG", true);
    //   // message = '未登录，请前往登录！'
    //   // MessageBox.confirm(message, '提示', {
    //   //   confirmButtonText: '确定',
    //   //   cancelButtonText: '取消',
    //   //   type: 'warning'
    //   // })
    //   //   .then(() => {
    //   //     store.dispatch('FedLogOut').then(() => {
    //   //       if (router.currentRoute.fullPath !== '/login') {
    //   //         window.sessionStorage.setItem('urlAfterLogin', window.location.href) // 记下当前在哪个页面，登录状态失效后重新登录，就跳转到这个页面来
    //   //       }
    //   //       return Promise.reject(new Error('未授权'))
    //   //     })
    //   //     router.replace('/login')
    //   //   })
    //   //   .catch(() => {})
    //   return;
    // }
    // 如果请求为非200否者默认统一处理
    if (status !== 200) {
      Message({
        message,
        type: "error",
        duration: 3000
      });
      return Promise.reject(new Error(message));
    }
    return res;
  },
  error => {
    return Promise.reject(new Error(error));
  }
);

export default request;



// WEBPACK FOOTER //
// ./src/utils/axios.js